import {Component, ElementRef, Input, ViewChild,inject} from "@angular/core";
import {IColorBar, IDataPoint} from "./color-bar.interface";
import {Dayjs} from "dayjs";
import * as dayjs from "dayjs";
import {ISunInfo} from "../../../../wrapper/global-alert/alerts/global-popup-control-program-edit/global-popup-control-program-edit.interface";
import {TranslateService} from "../../../services/translate/translate.service";

@Component({
    selector: 'color-bar',
    templateUrl: './color-bar.component.html',
    styleUrls: ['./color-bar.component.scss'],
})
export class ColorBarComponent {
    @ViewChild('sunset', {static: false}) sunsetChild:ElementRef;
    @ViewChild('sunrise', {static: false}) sunriseChild:ElementRef;
    @Input() chartArea:any;
    @Input() data: IColorBar[] = [];
    @Input() sunInfo:ISunInfo = null;

    private totalMinutesPerDay = 1440;


    private ts = inject(TranslateService)

    get dataPointList(): IDataPoint[]{
        const staticLastPoint:Dayjs = dayjs('1970-01-02 12:00:00');
        let dataPoints: IDataPoint[] = [];
        if(this.data.length > 0){
            this.data.map((_x,index) => {
                const nextPointIndex:number = index+1;
                let nextDatePoint:Dayjs;

                if (nextPointIndex < this.data.length && _x.timestamp != staticLastPoint) {
                    nextDatePoint = this.data[index+1].timestamp;
                } else {
                    nextDatePoint = staticLastPoint;
                }
                const totalMinutes:number = this.calculateTotalMinutes(_x.timestamp,nextDatePoint);
                dataPoints.push({
                    colorHex: _x.colorHex,
                    colorTemp: _x.colorTemp,
                    timestamp: _x.timestamp,
                    width:this.calculatePointWidth(totalMinutes),
                    totalMinutes: totalMinutes,
                })
            })

            return dataPoints;
        } else {
            return [];
        }
    }

    get sunriseWidth():number{
        const sunriseStart:Dayjs = dayjs('1970-01-01 '+this.sunInfo.sunrise.max);
        const sunriseEnd:Dayjs = dayjs('1970-01-01 '+this.sunInfo.sunrise.min);
        const totalMinutes:number = this.calculateTotalMinutes(sunriseStart,sunriseEnd)
        return this.calculateSunInfoWidth(totalMinutes);
    }

    get sunsetWidth():number{
        const sunsetStart:Dayjs = dayjs('1970-01-01 '+this.sunInfo.sunset.min);
        const sunsetEnd:Dayjs = dayjs('1970-01-01 '+this.sunInfo.sunset.max);
        const totalMinutes:number = this.calculateTotalMinutes(sunsetStart,sunsetEnd)
        return this.calculateSunInfoWidth(totalMinutes);
    }

    get sunrisePositionOffset():number{
        return this.calculateLeftOffset(this.sunInfo.sunrise.max, true)
    }

    get sunsetPositionOffset():number{
        return this.calculateLeftOffset(this.sunInfo.sunset.min, false)
    }

    get sunriseCurrentOffset():number{
        return this.calculateLeftOffset(this.sunInfo.sunrise.now, true)-7 //Icon position correction
    }

    get sunsetCurrentOffset():number{
        return this.calculateLeftOffset(this.sunInfo.sunset.now, false)-3 //Icon position correction
    }

    public tooltipText(type:'sunset_period'|'sunrise_period'|'sunset_current'|'sunrise_current'):string{
        switch (type) {
            case 'sunset_period':
                return this.ts.translate('color-bar.period-label')+' '+this.sunInfo.sunset.min+' - '+this.sunInfo.sunset.max;
            case 'sunrise_period':
                return this.ts.translate('color-bar.period-label')+' '+this.sunInfo.sunrise.max+' - '+this.sunInfo.sunrise.min;
            case 'sunset_current':
                return this.ts.translate('color-bar.sunset-label')+' '+this.sunInfo.sunset.now;
            case 'sunrise_current':
                return this.ts.translate('color-bar.sunrise-label')+' '+this.sunInfo.sunrise.now;
            default:
                return '';
        }
    }

    private calculatePointWidth(totalMinutes:number):number{
        const totalWidth = ((totalMinutes / this.totalMinutesPerDay) * 100).toFixed(2);
        return Number(totalWidth);
    }

    private calculateSunInfoWidth(totalMinutes:number):number{
        const oneMinuteWidth:number = this.chartArea.width / this.totalMinutesPerDay;
        return totalMinutes * oneMinuteWidth;
    }

    private calculateTotalMinutes(currentDate:Dayjs, nextDate:Dayjs):number{
        return nextDate.diff(currentDate, 'minutes')
    }

    private calculateMinuteOfTheDay(time:string):number{
        const timeParts:string[] = time.split(':');
        return Number(timeParts[0]) * 60 + Number(timeParts[1]);
    }

    private calculateLeftOffset(time:string, isNextDay:boolean):number{
        const oneMinuteWidth:number = this.chartArea.width / this.totalMinutesPerDay;
        const removeMinutes:number = isNextDay ? -(this.totalMinutesPerDay/2) : this.totalMinutesPerDay/2;
        return (this.calculateMinuteOfTheDay(time) - removeMinutes) * oneMinuteWidth;
    }
}
